import { ENV, PublicConfig, SUB_ENV } from './types';

export const isAvailableOnEnv = (currentEnvironment: ENV, environments: ENV[]) =>
  environments.includes(currentEnvironment);

export const isAvailableOnSubEnv = (
  currentEnvironment: SUB_ENV | undefined,
  environments: SUB_ENV[],
) => Boolean(currentEnvironment && environments.includes(currentEnvironment));

export const isDevOrSandbox = ({ ENVIRONMENT }: Pick<PublicConfig, 'ENVIRONMENT'>) =>
  isAvailableOnEnv(ENVIRONMENT, ['dev', 'sandbox']);

export const isDevOrSandboxOrStaging = ({ ENVIRONMENT }: Pick<PublicConfig, 'ENVIRONMENT'>) =>
  isAvailableOnEnv(ENVIRONMENT, ['dev', 'sandbox', 'staging']);

export const isAvailableFromDevToPreProd = ({
  ENVIRONMENT,
  SUB_ENVIRONMENT,
}: Pick<PublicConfig, 'ENVIRONMENT' | 'SUB_ENVIRONMENT'>) =>
  isDevOrSandboxOrStaging({ ENVIRONMENT }) ||
  isAvailableOnSubEnv(SUB_ENVIRONMENT, ['pre-production']);
